const BASE_URL = window.API_URL_OVERRIDE || __API_URL__;

// NOTE: Don't use any of these utils as they have been retired. Use the
// `useApiService` service instead. See:
// https://hello.atlassian.net/browse/PSREAU-463.

async function responseProcessor<T>(response: Response): Promise<T> {
  let json;
  try {
    json = await response.json();
  } catch (e) {
    json = {
      name: e.name || 'Network Error',
      status: response.status,
      message: response.statusText || e.message,
    };
  }

  if (response.ok) {
    return json;
  }

  /* eslint-disable-next-line prefer-promise-reject-errors */
  return Promise.reject({
    /* this message override should only appear if the API has broken and given us a malformed response */
    message: 'An unknown API error has occurred. Please reach out to us at #help-tome for triage.',
    ...json,
  } as API.Error);
}

export function _delete<T>(path: string): Promise<T> {
  return fetch(`${BASE_URL}/api${path}`, { method: 'DELETE', credentials: 'include' }).then<T>(
    responseProcessor
  );
}

export function get<T = API.Response<API.Entity>>(path: string): Promise<T> {
  return fetch(`${BASE_URL}/api${path}`, { credentials: 'include' }).then<T>(responseProcessor);
}

export function post<T = API.Response<API.Entity>>(path: string, options: RequestInit): Promise<T> {
  return fetch(`${BASE_URL}/api${path}`, {
    method: 'POST',
    body: options.body,
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  }).then<T>(responseProcessor);
}

export function put<T = API.Response<API.Entity>>(path: string, options: RequestInit): Promise<T> {
  return fetch(`${BASE_URL}/api${path}`, {
    method: 'PUT',
    body: options.body,
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  }).then<T>(responseProcessor);
}

export function patch<T = API.Response<API.Entity>>(
  path: string,
  options: RequestInit
): Promise<T> {
  return fetch(`${BASE_URL}/api${path}`, {
    method: 'PATCH',
    body: options.body,
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  }).then<T>(responseProcessor);
}

export function identity<T>(arg: T): T {
  return arg;
}

export function noop(): void {}
